import { Configs } from ".";

export default {
  REACT_APP_TAP_PAY_ID: process.env.REACT_APP_TAP_PAY_ID,
  REACT_APP_TAP_PAY_API_KEY: process.env.REACT_APP_TAP_PAY_API_KEY,
  REACT_APP_TAP_PAY_API: process.env.REACT_APP_TAP_PAY_API,
  REACT_APP_TAP_PAY_MODE: process.env.REACT_APP_TAP_PAY_MODE,
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY:
    process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY,
} as Configs;
